import React from "react"
import styled from "styled-components"
import { RelatedFetch } from "../RelatedArticle/RelatedFetch"
import { FacebookSquare, Twitter } from "@styled-icons/boxicons-logos"
import { Mail } from "@styled-icons/entypo/Mail"
import { AuthorSection } from "./AuthorSection"
import {
	Container,
	TopContainer,
	Line,
	CategoriesContainer,
	LeftSide,
	Category,
	RelatedContainer,
	RelatedHeading,
	Tags,
	RightSide,
	FlexArticles,
	FBicon,
	TwitterIcon,
	MailIcon,
	RelatedMaxWidth,
} from "./PostFooter.styles"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"

const responsive = {
	desktop: {
		breakpoint: { max: 3000, min: 1024 },
		items: 3,
		slidesToSlide: 3, // optional, default to 1.
	},
	tablet: {
		breakpoint: { max: 1024, min: 464 },
		items: 2,
		slidesToSlide: 2, // optional, default to 1.
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 1,
		partialVisibilityGutter: 100,
		slidesToSlide: 1, // optional, default to 1.
	},
}

export const PostFooter = ({ data }) => {
	const articleData = data.results[0].data
	const tags = data.results[0].tags
	const sliceZone = articleData.body

	const firstRelated = data.results[0].data.first_related_article.uid
	const secondRelated = data.results[0].data.second_related_article.uid
	const thirdRelated = data.results[0].data.third_related_article.uid

	const relatedArray = [firstRelated, secondRelated, thirdRelated]

	if (firstRelated) {
		return (
			<>
				<Container>
					<TopContainer>
						<Line></Line>
						<CategoriesContainer>
							<LeftSide>
								<Category>CATEGORIES</Category>
								{tags.map(function (tag, index) {
									return <Tags key={index}>{tag}</Tags>
								})}
							</LeftSide>
							<RightSide>
								SHARE <FBicon size="13"></FBicon>
								<TwitterIcon size="13"></TwitterIcon>
								<MailIcon size="13"></MailIcon>
							</RightSide>
						</CategoriesContainer>
						<AuthorSection data={data} />
					</TopContainer>

					<RelatedContainer>
						<RelatedMaxWidth>
							<RelatedHeading>Related Articles</RelatedHeading>
							<FlexArticles>
								{relatedArray.map((related, i) => {
									return (
										<>
											<RelatedFetch data={related} value={i} />
										</>
									)
								})}
							</FlexArticles>
							<Carousel
								swipeable={true}
								draggable={true}
								showDots={false}
								responsive={responsive}
								partialVisible={true}
								ssr={true} // means to render carousel on server-side.
								infinite={false}
								keyBoardControl={true}
								customTransition="all .5"
								transitionDuration={500}
								containerClass="carousel-container"
								removeArrowOnDeviceType={["tablet", "mobile"]}
								dotListClass="custom-dot-list-style"
								itemClass="carousel-item-padding-40-px"
							>
								{relatedArray.map((related, i) => {
									return (
										<>
											<RelatedFetch data={related} value={i} />
										</>
									)
								})}
							</Carousel>
						</RelatedMaxWidth>
					</RelatedContainer>
				</Container>
			</>
		)
	}
	return <></>
}

function returnTags(props) {
	return (
		<>
			<div>{props.tags}</div>
		</>
	)
}
